import { createReducer } from "../../../common/reduxUtil";
import { SAT_SET_GUEST, SAT_SET_GUEST_PREVIEW, SAT_SET_USER } from "./types";

// `user` is undefined while account state loads and null signed out; `guest` is set only on /app.
const initialState = {
  user: undefined,
  guest: null,
  guestPreview: null,
  guestPreviewStatus: "idle",
};

export default createReducer(initialState, {
  [SAT_SET_USER]: (state, user) => ({ ...state, user }),
  [SAT_SET_GUEST]: (state, guest) => ({ ...state, guest }),
  [SAT_SET_GUEST_PREVIEW]: (state, { status, preview }) => ({
    ...state,
    guestPreview: preview,
    guestPreviewStatus: status,
  }),
});
